import React, { FC } from 'react';
import { appConfig } from '@minecraft.app-config';
import { useTranslation } from '@blocs.i18n';
import { captureHeapEvent, HEAP_EVENT_NAMES } from '@blocs.heap';
import { PromotionalBanner } from '@blocs.promotional-banner';
import { useRouter } from '@blocs.router';

export const TRIAL_PROFILE_READY_BANNER_BG = `${appConfig.cdnRoot}/images/static/banner-source.jpg`;

interface TrialProfileReadyBannerProps {
  profileUrl: string;
}

export const TrialProfileReadyBanner: FC<TrialProfileReadyBannerProps> = ({ profileUrl }) => {
  const { t } = useTranslation();
  const { navigate } = useRouter();

  return (
    <PromotionalBanner
      title={t('common:paywall.trial.profileReadyBanner.title')}
      subtitle={t('common:paywall.trial.profileReadyBanner.subtitle')}
      ctaLabel={t('common:paywall.trial.profileReadyBanner.cta')}
      onClick={() => {
        captureHeapEvent({ name: HEAP_EVENT_NAMES.GLOBAL_PROFILE_BANNER_CTA_CLICKED });
        navigate({ to: profileUrl });
      }}
      image={TRIAL_PROFILE_READY_BANNER_BG}
      testId="paywall-trial-profile-ready-banner"
      ctaTestId="paywall-trial-profile-ready-banner-cta"
      heapId="global-banner-review-profile"
    />
  );
};
